const MODULE_NAME = 'PHYSICIAN';
const PHYSICIAN_FETCH_STARTED = MODULE_NAME + 'PHYSICIAN_FETCH_STARTED';
const PHYSICIAN_FETCH_COMPLETED = MODULE_NAME + 'PHYSICIAN_FETCH_COMPLETED';
const PHYSICIAN_FETCH_FAILED = MODULE_NAME + 'PHYSICIAN_FETCH_FAILED';

export {
  PHYSICIAN_FETCH_STARTED, PHYSICIAN_FETCH_COMPLETED, PHYSICIAN_FETCH_FAILED
};
